// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
// styles
import 'font-awesome/less/font-awesome.less';
import './RelatedTransaction.less';

class RelatedTransactionsFilters extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    togglePacerFilterSection: PropTypes.func,
    case_uuid: PropTypes.string,
    loadingSpinner: PropTypes.bool,
    showPacerFilterSection: PropTypes.bool,
  };

  static defaultProps = {
    case_uuid: '',
    onSubmit: () => null,
    togglePacerFilterSection: () => null,
    loadingSpinner: false,
    showPacerFilterSection: true,
  };

  render() {
    const {
      onSubmit,
      loadingSpinner,
    } = this.props;

    const DateField = ({ input, label, ...rest }) => (
      <DatePicker
        {...input}
        minDate={moment().subtract(15, 'years')}
        maxDate={moment()}
        selected={input.value ? moment(input.value) : null}
        dateFormat="MM/DD/YYYY"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        placeholderText="date"
        {...rest}
      />
    );
    const options = [
      { value: 'answer', label: 'answer' },
      { value: 'auditor', label: 'auditor' },
      { value: 'appeal', label: 'appeal' },
      { value: 'caseupld', label: 'caseupld' },
      { value: 'claims', label: 'claims' },
      { value: 'cmp', label: 'cmp' },
      { value: 'cmpX', label: 'cmpX' },
      { value: 'court', label: 'court' },
      { value: 'crditcrd', label: 'crditcrd' },
      { value: 'hrg', label: 'hrg' },
      { value: 'misc', label: 'misc' },
      { value: 'motion', label: 'motion' },
      { value: 'nef', label: 'nef' },
      { value: 'notice', label: 'notice' },
      { value: 'order', label: 'order' },
      { value: 'plan', label: 'plan' },
      { value: 'trustee', label: 'trustee' },
      { value: 'utility', label: 'utility' },
    ];
    const SelectField = ({ input, ...rest }) => (
      <div className="select-parent">
        <Select
          {...input}
          {...rest}
          onBlurResetsInput={false}
          onSelectResetsInput={false}
          simpleValue
          clearable={false}
          searchable={false}
          />
      </div>
    );

    const pending = true;
    return (
      <Form
      initialValues={{ pending }}
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        pristine,
        form,
        submitting,
        }) => (
          <div id="pacer-filter" className="inside-block">
            {this.props.showPacerFilterSection ? <a className="hide-link filter_btn" onClick={() => this.props.togglePacerFilterSection()} >Hide Pacer search</a> :
            <a className="hide-link filter_btn" onClick={() => this.props.togglePacerFilterSection()} >Show Pacer search</a>
              }
            {!this.props.showPacerFilterSection && <div id="related-form"><div className="tip">Leave blank for all dockets or specify document or date range to search partial docket sheet</div></div>}
            {this.props.showPacerFilterSection &&
              <form onSubmit={handleSubmit} id="related-form">
                <div className="tip">Leave blank for all dockets or specify document or date range to import partial docket sheet</div>
                <div className="related-form-row">
                  <Field
                  name="doc_from"
                  component="input"
                  type="text"
                  placeholder="Doc#"
                  />
                  <label htmlFor="doc_to">to
                <Field
                    name="doc_to"
                    component="input"
                    type="text"
                    placeholder="Doc#"
                />
                  </label>
                  <label htmlFor="date_from">&nbsp; OR &nbsp;
                  <Field
                      name="date_from"
                      component={DateField}
                      type="text"
                      placeholder="Date"
                  />
                  </label>
                  <label htmlFor="date_to">&nbsp; to &nbsp;
                  <Field
                      name="date_to"
                      component={DateField}
                      type="text"
                      placeholder="Date"
                  />
                  </label>
                  <label htmlFor="doc_type"> Type:
                   <Field
                    name="doc_type"
                    component={SelectField}
                    options={options}
                    placeholder="select..."
                    />
                
                  </label>
                  <button type="submit" disabled={submitting} className="form-submit green">
                    {loadingSpinner ? <i className="fa fa-spinner fa-spin" /> : <div>Pacer Search</div>}
                  </button>
                  <button
                  type="reset"
                  onClick={() => form.reset()}
                  disabled={submitting}
                  className="form-reset">
                  Clear/ Show All
                  </button>
                </div>
                <div className="related-form-row">
                  <label htmlFor="pending">Pending:
                <Field
                  name="pending"
                  component="input"
                  type="checkbox"
                />
                  </label>
                  <label htmlFor="terminated">Terminated:
                <Field
                  name="terminated"
                  component="input"
                  type="checkbox"
                />
                  </label>
                </div>
              </form>
          }
          </div>)}
      />
    );
  }
}

export default RelatedTransactionsFilters;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransactionsFilters.jsx